<template>
  <div class="login-box">
    <div class="login-logo">
      <img :src="$config.imgDir + '/logo.png'">
    </div>
    <form>
      <div class="login-box-body" style="border-top: 4px solid #3c8dbc;">
        <p class="login-box-msg">Criar Senha</p>
        <div>
          <div class="form-group has-feedback">
            <input type="password"
              v-model="password"
              name="password"
              id="password"
              required=""
              class="form-control"
              placeholder="Senha"
              @keyup="validateForm"
              >
            <span class="glyphicon glyphicon-lock form-control-feedback"></span>
            <p class="text-red">{{passwordError}}</p>
          </div>
          <div class="form-group has-feedback">
            <input
              type="password"
              v-model="repeatPassword"
              name="repeatPassword"
              id="repeat-password"
              required=""
              class="form-control"
              placeholder="Repita a Senha"
              @keyup="validateForm"
              >
            <span class="glyphicon glyphicon-lock form-control-feedback"></span>
          </div>
          <div class="row">
            <div class="col-xs-6">
            </div>
            <div class="col-xs-6">
              <button type="submit" class="btn btn-sm btn-primary pull-right" :disabled="!isValid()" v-on:click.prevent="submit">
                <i class="fa fa-sign-in"></i>&nbsp; Salvar
              </button>
            </div>
          </div>
        </div>
        <br>
      </div>
    </form>
  </div>
</template>

<script>
import {BackendApi} from '@/services/backend_api'

export default {
  name: 'ResetPassword',
  props: ['token'],
  data: function () {
    return {
      password: '',
      repeatPassword: '',
      passwordError: '',
      logo: ''
    }
  },
  methods: {
    submit () {
      BackendApi.getAnonymousClient().put(`users/password`, { token: this.token, plainPassword: this.password })
        .then(response => { this.redirect() })
        .catch(e => { throw e })
    },
    clearFormErrors () {
      this.passwordError = ''
    },
    redirect () {
      this.$router.push({name: 'Homepage'})
    },
    validateForm () {
      this.clearFormErrors()

      if (this.password !== this.repeatPassword) {
        this.passwordError = 'As senhas não coincidem'
        return
      }

      if (this.password.length < 8) {
        this.passwordError = 'A senha deve ter no mínimo 8 caracteres'
      }
    },
    isValid () {
      return (this.password) && (this.password === this.repeatPassword) && (this.password.length > 7)
    },
    isTokenValid () {
      return BackendApi.getAnonymousClient().get(`users/password-creation-token/${this.token}`)
    }
  },
  mounted () {
    this.logo = this.$config.logo
    document.body.classList = 'login-page'

    this.isTokenValid()
      .catch(e => {
        if (e.response.status === 404) {
          this.$router.push({name: 'NotFoundError'})
        }
      })
  }
}
</script>



// WEBPACK FOOTER //
// ResetPassword.vue?37a02b4c